export default __webpack_public_path__ + "static/the-biggest-bluff-faac98fa587aeecd08c6145d4e0dfbf3.jpg";